import aphrodite from 'aphrodite';

var regex = /^>[.#:][-\w()]+$/im;

function descendant(selector, baseSelector, generateSubtreeStyles) {
  if (!selector.match(regex)) {
    return null;
  }

  var childSelector = selector.slice(1);
  return generateSubtreeStyles(baseSelector + ' > ' + childSelector);
}

var myExtension = { selectorHandler: descendant };

var myAphrodite = aphrodite.StyleSheet.extend([myExtension]);
export default myAphrodite;

var css = myAphrodite.css,
    StyleSheet = myAphrodite.StyleSheet;

export { css, StyleSheet };